module.exports = __webpack_public_path__ + "videos/gestures_en.0db2d54.mp4";